module.exports = __webpack_public_path__ + "img/huaxia02.45e69b55.png";